// ============================================================
// セルフ利用ガイド共通: 拠点情報の取得フックと静的データ
// - 拠点/担当店は既存API（/lpspot/index.php・/company/index.php）から取得
// - 拠点のセルフ対応タイプは lpspot のフィールドから判定
//   （locker_image の有無でロッカー拠点/店頭のみを区別。
//     本番D1で全拠点を確認済み: ロッカー拠点=画像あり・店頭のみ=画像なし）
// ============================================================
import { useEffect, useState } from 'react';
import { Post } from '../../compornents/Post';
import { spotSelfAtStore } from '../../selfDropoff';

// 拠点のセルフ対応タイプ
//   'locker' : お客様がロッカーに預けられる
//   'store'  : ロッカーなし・店頭でのお預け（営業時間内のみ）
//   'none'   : セルフ預入れ未対応（例: 海神クリーニング 瑞江・船堀）
export function spotSelfType(lpspot) {
  if (!lpspot) return 'none';
  const selfok = Number(lpspot.can_user_dropoff_locker) === 1;
  if (!selfok) return 'none';
  if (spotSelfAtStore(lpspot)) return 'store'; // 店頭モードの拠点（#613・船堀店）はロッカー写真があっても店頭
  return lpspot.locker_image ? 'locker' : 'store';
}

// 拠点住所（場所の説明用）
export function spotAddress(lpspot) {
  if (!lpspot) return '';
  return [lpspot.pref, lpspot.add1, lpspot.add2, lpspot.add3].filter(Boolean).join('');
}

// 自分の拠点＋担当クリーニング店を取得するフック
// （要ログイン。未ログインなら Post が /login へリダイレクトする）
export function useSelfSpotInfo() {
  const [lpspot, setLpspot] = useState(null);
  const [gcompany, setGcompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const [spotRes, companyRes] = await Promise.all([
        Post('post', '/lpspot/index.php', {}),
        Post('post', '/company/index.php', {}),
      ]);
      if (!mounted) return;
      if (spotRes?.result === 1) setLpspot(spotRes.lpspot);
      if (companyRes?.result === 1) setGcompany(companyRes.gcompany);
      setLoading(false);
    })();
    return () => { mounted = false; };
  }, []);

  return { lpspot, gcompany, loading };
}

// タッチパネル最初の画面（管理画面ロッカー操作ガイド guide_img_menu の1枚目・R2公開URL）
export const TP_MENU_IMG = 'https://api.laundrypack.app/img/guide/1782107652370-8c2d6c0583efdca9.png';

// 現在地からの徒歩ナビURL（Googleマップ。アプリがあればアプリで開く）
// 本体 Home/[id].jsx のナビボタン(v1.10.12)と同じ形式。
export function navUrl(lat, lon) {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}&travelmode=walking`;
}

// セルフ対応できる拠点の一覧（/self_spots 用の静的データ）
// 本番lpspot・company の設定値（2026-08-31 D1確認）を反映。
// TODO: 将来は拠点一覧APIを追加して動的化する（現状は顧客向け一覧APIが無い）。
export const SELF_SPOTS = [
  { name: 'ニュースタイルラボ 大楠本店', company: 'ラクーンデリバリー', type: 'locker', lat: '33.57013952', lon: '130.41072965' },
  { name: 'ウェアプラス', company: 'ウェアプラス', type: 'locker', lat: '35.657526', lon: '139.860966' },
  { name: 'マックスバリュEX竹下通り店横', company: 'ラクーンデリバリー', type: 'locker', lat: '33.579440', lon: '130.424709' },
  { name: 'fgn前ロッカー', company: 'ラクーンデリバリー', type: 'locker', lat: '33.589028', lon: '130.395361' },
  { name: 'クリーニングオノ 経堂店', company: '小野ドライ', type: 'locker', lat: '35.645900', lon: '139.628679' },
  { name: 'クリーニングオノ 若林店', company: '小野ドライ', type: 'locker', lat: '35.642425', lon: '139.660142' },
  { name: 'クリーニング ワールド 三山車庫前店', company: 'ワールド', type: 'store', hours: '10:00〜18:00・水曜定休', lat: '35.69873621360367', lon: '140.05752921475786' },
  // 白光舎 船堀店（lpspot15）は 2026-10-08 から店頭でセルフ受付（ロッカーはUber配達員専用のため店頭・#613）。
  { name: 'クリーニング白光舎 船堀店', company: '海神クリーニング', type: 'store', hours: '平日10:00〜15:00・土日祝9:00〜19:00・火水定休', lat: '35.682017', lon: '139.864887' },
  // 白光舎 瑞江店（lpspot14）はセルフ未対応（2026-10-06 白光舎 大橋さん「瑞江店はこのまま」）。
];
